const menu = document.querySelector('.header .menus_wrapper')
const menuBurger = document.querySelector('.header .menu_btn_burger')

if (menu && menuBurger) {
  menuBurger.onclick = (e) => {
    e.preventDefault()

    toggleMenu()
  }
}

const openMenu = () => {
  menuBurger.classList.add('open')
  menu.classList.add('open')
  window.document.body.classList.add('responsive_menu_open')
}

const closeMenu = () => {
  menuBurger.classList.remove('open')
  menu.classList.remove('open')
  window.document.body.classList.remove('responsive_menu_open')

}

const toggleMenu = () => {
  if (menuBurger.classList.contains('open')) {
    closeMenu()
  } else {
    openMenu()
  }
}



// WEBPACK FOOTER //
// ./scripts/menu.js